import {
    COMMS_PARAMETER_TEXT1_FIELD_NAME,
    COMMS_PARAMETER_TEXT2_FIELD_NAME,
    IP_ADDRESS1_FIELD_NAME,
    IP_ADDRESS2_FIELD_NAME,
    IP_ADDRESS3_FIELD_NAME,
    IP_ADDRESS4_FIELD_NAME,
    OUTBOUND_TEL_NO_PREFIX_FIELD_NAME,
    PASSWORD1_FIELD_NAME,
    PASSWORD2_FIELD_NAME,
    PASSWORD3_FIELD_NAME,
    PASSWORD4_FIELD_NAME,
    SIMULATION_MODE_FIELD_NAME,
    USER_NAME1_FIELD_NAME,
    USER_NAME2_FIELD_NAME,
    USER_NAME3_FIELD_NAME,
    USER_NAME4_FIELD_NAME,
    XSP_SERVER_FIELD_NAME
} from './FieldNames'
import { TelSysTypes } from '../../../NonReact/constants/TelephonyServerTypes'

export enum TelSysConfigurationModalID {
    TELSYS_DETAILS = 0,
    TELSYS_COMMUNICATIONS = 1,
    TELSYS_SYNC = 2,
    TELSYS_DEFAULT_SITE_SETTINGS = 3,
    TELSYS_LICENSE_MANAGEMENT = 4,
    TELSYS_ADVANCED = 5
}

export const TEL_SYS_TYPE_VALUE_MAP: Record<string, string> = {
    [TelSysTypes.UNKNOWN]: '-1',
    [TelSysTypes.SIMULATOR]: '1',
    [TelSysTypes.WEBEX_CALLING]: '25',
    [TelSysTypes.BROADSOFT_BROADWORKS]: '7',
    [TelSysTypes.SIEMENS_HIPATH_3000]: '15',
    [TelSysTypes.PANASONIC_TDA_NCP]: '20',
    [TelSysTypes.BROADSOFT_M6]: '5',
    [TelSysTypes.MS_TEAMS]: '30'
}

export const TEL_SYS_PROFILE_TO_FORM_VALUE_MAP: Record<string, string> = {
    IPAddress1DefaultTelSrvs: IP_ADDRESS1_FIELD_NAME,
    IPAddressXSPDefaultTelSrvs: XSP_SERVER_FIELD_NAME,
    IPAddress2DefaultTelSrvs: IP_ADDRESS2_FIELD_NAME,
    AuthUserID1DefaultTelSrvs: USER_NAME1_FIELD_NAME,
    AuthPassword1DefaultTelSrvs: PASSWORD1_FIELD_NAME,
    AuthUserID2DefaultTelSrvs: USER_NAME2_FIELD_NAME,
    AuthPassword2DefaultTelSrvs: PASSWORD2_FIELD_NAME,
    IPAddress3DefaultTelSrvs: IP_ADDRESS3_FIELD_NAME,
    IPAddress4DefaultTelSrvs: IP_ADDRESS4_FIELD_NAME,
    AuthUserID3DefaultTelSrvs: USER_NAME3_FIELD_NAME,
    AuthPassword3DefaultTelSrvs: PASSWORD3_FIELD_NAME,
    AuthUserID4DefaultTelSrvs: USER_NAME4_FIELD_NAME,
    AuthPassword4DefaultTelSrvs: PASSWORD4_FIELD_NAME,
    TelNoPrefixesDefaultTelSrvs: OUTBOUND_TEL_NO_PREFIX_FIELD_NAME,
    CommsParamText1DefaultTelSrvs: COMMS_PARAMETER_TEXT1_FIELD_NAME,
    CommsParamText2DefaultTelSrvs: COMMS_PARAMETER_TEXT2_FIELD_NAME,
    CallCtrlCapabilityFlagsFilterDefaultTelSrvs: SIMULATION_MODE_FIELD_NAME
}

export enum LicencedForRptTypes {
    LITE = 'Akixi Lite',
    ONE_THOUSAND = 'Akixi 1000',
    TWO_THOUSAND = 'Akixi 2000'
}

export const LICENCED_FOR_LIST: LicencedForRptTypes[] = [
    LicencedForRptTypes.LITE,
    LicencedForRptTypes.ONE_THOUSAND,
    LicencedForRptTypes.TWO_THOUSAND
]

export const INTEGRATION_MODE_HISTORIC = 0
export const INTEGRATION_MODE_REAL_TIME = 1

export const DEFAULT_TIMEZONE: string = 'Europe/London'
export const DEFAULT_COUNTRY_CODE: number = 44
export const DEFAULT_INTERNAL_DIGIT_LENGTH: number = 4
export const DEFAULT_OUTBOUND_TEL_NO_PREFIX: string = '9'

export const DEFAULT_MAX_PARTITION_COUNT: number = 80
export const DEFAULT_MAX_USERS_SYNC: number = 3000
export const DEFAULT_MAX_USERS_MONITORED: number = 600
export const DEFAULT_ENTERPRISE_USER_EXTENSIONS: number = 50

export const DEFAULT_TEL_SYS_PROFILE_ID: string = 'default.profile01'

export const PASSWORD_PLACEHOLDER: string = '********'

export const ALL_TELSYS_ID: number = -1
export const NONE_SELECTED: string = '-1'

export const SIEMENS_DEFAULT_TCP_PORT: number = 7001
export const PANASONIC_DEFAULT_TCP_PORT: number = 33333
export const M6_DEFAULT_TCP_PORT: number = 29051
export const CTI_INTERFACE_TCP_PORT: number = 8011
export const OCI_API_TCP_PORT: number = 2208
export const XSI_EVENT_CONTEXT: string = '/com.broadsoft.xsi-events'
export const XSI_ACTIONS_CONTEXT: string = '/com.broadsoft.xsi-actions'

export const LICENCE_VALUE_NONE: string = '[None]'
export const LICENCE_VALUE_HIDDEN: string = '[Hidden]'

export const TELSYS_MODAL_CONFIG_FILENAME: string = 'telsys-modal-config'
export const KEY_FOR_STATUS_CALL_FREQUENCY: string = 'statusCallFequency'

export const MAX_DEFAULT_SCHEDULED_REPORTS_ALLOWED_PER_USER: number = 40
export const MAX_DEFAULT_SCHEDULED_EMAILS_ALLOWED_PER_REPORT: number = 50

export enum SyncEnvironments {
    AUTHORISER_SELECT,
    TENANT,
    SECURITY_GROUPS
}

export { TelSysTypes }
